import { Component, OnInit, Input } from '@angular/core';
import { ThingProvider } from '@providers/thing.provider';
import { NotificationService } from '@core/notification/notification.service';
import { RefreshEvent } from '@events/RefreshEvent';
import { ThingModalEvent } from '@events/ThingModalEvent';
import { ThingsUtil } from '../../../util/things';
import { Router } from '@angular/router';
import { FormConfig } from '../form/form.component';

@Component({
  selector: 'things-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.less']
})
export class ThingsEditComponent implements OnInit {

  @Input()
  public type:string = 'can';

  @Input()
  public config: FormConfig;

  constructor(private thing: ThingProvider, private notification: NotificationService, private refresher: RefreshEvent, private thingEvent: ThingModalEvent, private thingsUtil: ThingsUtil, private router: Router) {
  }

  ngOnInit() {

  }

  submit(thing) {
    return new Promise((resolve, reject) => {
      this.thing.updateThing(thing).then(res => {
        this.notification.show('success', 'You have successfully edited ' + thing.name + '.');
        this.refresher.fire('thingsDetails.refresh');
        resolve(res);
      }).catch(err => {
        this.notification.show('alert', 'An error occured while saving.');
        reject(err);
      });
    });
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/components/things/edit/edit.component.ts